export default __webpack_public_path__ + "static/media/hold-please.37298b6a.gif";